export enum AvatarSize {
    Smallest = 'smallest',
    Smaller = 'smaller',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    Larger = 'larger',
}
